import EditorPropsContext from './EditorPropsContext';

function EditorProvider({ children, ...props }) {
    return (
        <EditorPropsContext.Provider value={props}>
            {children}
        </EditorPropsContext.Provider>
    );
}

export default EditorProvider;
